import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Nav, Collapse } from "react-bootstrap";
import axios from "axios";
import { API_BASE_URL } from "config.js";

function Sidebar({ routes, image, background }) {
  const location = useLocation();
  const navigate = useNavigate();

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userName = user && user.name ? user.name : "Admin";
  const userRole = user && user.type ? user.type : "user";

  const [userCollapseState, setUserCollapseState] = React.useState(false);
  const [state, setState] = React.useState({});
  const [conversationVisible, setConversationVisible] = React.useState(false);
  const token = localStorage.getItem('token');
  React.useEffect(() => {
    setConversationVisible(false);
    if (!token) return;
    const controller = new AbortController();
    axios.get(`${API_BASE_URL}/conversations/capabilities`, { signal: controller.signal, headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => { if (!controller.signal.aborted) setConversationVisible(data.success === true && data.capabilities?.ui === true && data.capabilities?.read === true); })
      .catch(() => { if (!controller.signal.aborted) setConversationVisible(false); });
    return () => controller.abort();
  }, [token]);

  React.useEffect(() => {
    setState(getCollapseStates(routes));
  }, [routes]);

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/auth/login");
  };

  const getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };

  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (location.pathname === routes[i].layout + routes[i].path) {
        return true;
      }
    }
    return false;
  };

  const createLinks = (routes) => {
    return routes
      .filter((route) => !route.invisible)
      .filter((route) => !route.conversationFeature || conversationVisible)
      .filter((route) => {
        if (route.roles && !route.roles.includes(userRole)) {
          return false;
        }
        return true;
      })
      .map((prop, key) => {
      if (prop.redirect) return null;

      if (prop.collapse) {
        const st = {};
        st[prop.state] = !state[prop.state];

        return (
          <Nav.Item
            className={getCollapseInitialState(prop.views) ? "active" : ""}
            as="li"
            key={key}
          >
            <Nav.Link
              className={state[prop.state] ? "collapsed" : ""}
              data-toggle="collapse"
              onClick={(e) => {
                e.preventDefault();
                setState({ ...state, ...st });

                if (prop.name === "Campaigns") {
                  const campaignProgress = prop.views.find(
                    (view) => view.name === "Campaign Progress"
                  );
                  if (campaignProgress) {
                    navigate(campaignProgress.layout + campaignProgress.path);
                  }
                }
              }}
              aria-expanded={state[prop.state]}
            >
              <i className={prop.icon}></i>
              <p>
                {prop.name} <b className="caret"></b>
              </p>
            </Nav.Link>
            <Collapse in={state[prop.state]}>
              <div>
                <Nav as="ul">
                  {createLinks(
                    prop.views.filter((view) => view.name !== "Campaign Progress")
                  )}
                </Nav>
              </div>
            </Collapse>
          </Nav.Item>
        );
      }

      return (
        <Nav.Item
          className={activeRoute(prop.layout + prop.path)}
          key={key}
          as="li"
        >
          <Link to={prop.layout + prop.path} className="nav-link">
            {prop.icon ? (
              <>
                <i className={prop.icon} />
                <p>{prop.name}</p>
              </>
            ) : (
              <>
                <span className="sidebar-mini">{prop.mini}</span>
                <span className="sidebar-normal">{prop.name}</span>
              </>
            )}
          </Link>
        </Nav.Item>
      );
    });
  };

  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  return (
    <div className="sidebar pt-4" style={{ borderRight: '2px solid #Dee2e6' }}>
      <div className="sidebar-wrapper">
        <button
          className="btn-round bg-white sidebarTogglebtn"
          style={{
            position: "absolute",
            top: "40px",
            right: "-20px",
            zIndex: "100000000",
            border: "1px solid #DBDBDB",
            padding: "5px",
            height: "40px",
            width: "40px",
          }}
          onClick={() => document.body.classList.toggle("sidebar-mini")}
        >
          <i style={{ color: "black", fontSize: '25px' }} className="fas fa-angle-left visible-on-sidebar-regular"></i>
          <i style={{ color: "black", fontSize: '25px' }} className="fas fa-angle-right visible-on-sidebar-mini"></i>
        </button>
        <Nav as="ul">{createLinks(routes)}</Nav>

        {/* ── Logout ─────────────────────────────────────────── */}
        <Nav as="ul" style={{ borderTop: "1px solid rgba(128, 128, 128, 0.2)", marginTop: "10px", paddingBottom: "20px" }}>
          <Nav.Item as="li">
            <Nav.Link id="sidebar-logout-btn" onClick={handleLogout} style={{ cursor: "pointer" }}>
              <i className="fas fa-sign-out-alt" />
              <p>Logout</p>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
    </div>
  );
}

Sidebar.defaultProps = {
  image: "",
  background: "black",
  routes: [],
};

Sidebar.propTypes = {
  image: PropTypes.string,
  background: PropTypes.oneOf(["black", "azure", "green", "orange", "red", "purple"]),
  routes: PropTypes.array,
};

export default Sidebar;
